import { Calendar, HomeIcon, LayoutDashboard, LifeBuoy, Lightbulb, Settings, StickyNote } from "lucide-react";
import ThemeToggle from "../components/ThemeToggler";
import Sidebar, { SidebarItem } from "../layouts/Sidebar";

const menuItems = [
  { icon: <HomeIcon size={20} />, text: "Fleet metrics", link: "/" },
  { icon: <LayoutDashboard size={20} />, text: "Charger metrics", link: "/charger" },
  { icon: <StickyNote size={20} />, text: "OCPP messages", link: "/ocpp" },
  { icon: <Calendar size={20} />, text: "Logs download", link: "/logs" },
  { divider: true },
  { icon: <Settings size={20} />, text: "Settings" },
  { icon: <LifeBuoy size={20} />, text: "Help" },
  { icon: <Lightbulb size={20} />, text: <ThemeToggle /> },
];

function Menu() {
  return (
    <Sidebar>
      {menuItems.map((item, index) =>
        item.divider ? (
          <hr key={index} className="my-3" />
        ) : (
          <SidebarItem
            key={index}
            icon={item.icon}
            text={item.text}
            link={item.link}
            active={location.pathname === item.link}
          />
        )
      )}
    </Sidebar>
  );
}

export default Menu;
